import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { Icon, TIconVariant } from '@/shared/ui/icon'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import {
  $userLanguage,
  $userSettings,
  $userToken,
  getUserProfileFx,
  insertUserSettingsFx,
  SettingsEvents,
} from '@/entities/user'

import { getShareLinkFx } from '@/entities/integration/effects'
import WebApp from '@twa-dev/sdk'
import { useCallback, useState } from 'react'

export const FriendsPressedButton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const settings = useUnit($userSettings)
  const userToken = useUnit($userToken)
  const texts = lang[userLang].pages.main
  const text = !settings.friends_pressed ? texts.joinCommunity : texts.inviteFriends
  const icon: TIconVariant = !settings.friends_pressed ? 'joinCommunity' : 'telegram'
  const chatLink = userLang === 'ru' ? 'https://t.me/gamedcommunitycis' : 'https://t.me/gamedcommunity'

  const needToShowKeysReward = settings.friends_pressed === 1 && settings.claimedFriendsRewards === false
  const communityStyles = settings.friends_pressed ? { width: '20px', alignSelf: 'center', paddingBottom: '4px' } : {}

  const [isLoading, setIsLoading] = useState(false)

  const handleShare = useCallback(async () => {
    if (!settings?.friends_pressed) {
      WebApp.openTelegramLink(chatLink)
      await insertUserSettingsFx({
        token: userToken!,
        data: {
          key: SettingsEvents.FRIENDS_PRESSED,
          value: 1,
        },
      })
      await insertUserSettingsFx({
        token: userToken!,
        data: {
          key: SettingsEvents.HAS_CLAIMED_FRIEND_REWARD,
          value: false,
        },
      })
      await getUserProfileFx(userToken!)
    } else {
      try {
        setIsLoading(true)
        const link = await getShareLinkFx(userToken!)
        WebApp.shareMessage(link.message_id)
      } finally {
        setIsLoading(false)
      }
    }
  }, [chatLink, settings?.friends_pressed, userToken])

  return (
    <AppButton
      variant="primary"
      className={classes.joinCommunityButton}
      onClick={handleShare}
      isLoading={isLoading}
    >
      <Icon
        view={icon}
        style={{ paddingBottom: '0px', ...communityStyles }}
      />

      {needToShowKeysReward && (
        <div className={classes.keysContainer}>
          <Icon
            view="gamedKey"
            width={18}
          />
          <span>+2</span>
        </div>
      )}

      <span style={{ paddingTop: '0px' }}>{text}</span>
    </AppButton>
  )
}
